export function stickySupport() {
  return window.CSS
    && window.CSS.supports
    && typeof window.CSS.supports == 'function'
    && (window.CSS.supports('position:sticky') || window.CSS.supports('position:-webkit-sticky'))
}
